var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: 'full_name'
      }, _vm.additionalParams),
      "allow-create": false,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_user'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "limit": _vm.limit,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "flat": _vm.flat,
      "icon": _vm.icon,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      },
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex flex-column py-2"
        }, [_c('div', {
          staticClass: "text-body-2 font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.displayName(item)) + " ")]), item.email ? _c('div', {
          staticClass: "text-caption text--secondary"
        }, [_vm._v(" " + _vm._s(item.email) + " ")]) : _vm._e()])];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }